import React from 'react';
import { CONSTANTS } from '../utils/constants';
export const FinalCTA: React.FC = () => {
  const handleBuyClick = () => {
    window.open(CONSTANTS.PAYMENT_LINK, '_blank');
  };
  return <section className="py-24 text-center relative" style={{
    background: 'radial-gradient(ellipse at 50% 50%, rgba(200,163,78,0.06) 0%, transparent 70%)'
  }} data-id="element-61">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-62">
        <h2 className="font-serif text-4xl md:text-5xl font-bold mb-4 leading-tight" data-id="element-63">
          El oro siempre valió.
          <br data-id="element-64" />
          <span style={{
          color: 'var(--gold)'
        }} data-id="element-65">
            La pregunta es si vos vas a aprovecharlo.
          </span>
        </h2>

        <p className="text-lg md:text-xl mb-8 leading-relaxed" style={{
        color: 'var(--text-secondary)'
      }} data-id="element-66">
          Tenés la guía, los bonos, las herramientas y el plan de 7 días. Lo
          único que falta es tu decisión.
        </p>

        <button onClick={handleBuyClick} className="font-bold text-lg px-12 py-5 rounded-md uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 w-full sm:w-auto" style={{
        background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
        color: 'var(--bg-dark)',
        boxShadow: '0 4px 20px rgba(200,163,78,0.3)'
      }} data-id="element-67">
          SÍ, QUIERO ACCEDER AL PACK COMPLETO
        </button>

        <p className="mt-3 text-sm" style={{
        color: 'var(--text-muted)'
      }} data-id="element-68">
          Acceso inmediato + 3 Bonos incluidos hoy
        </p>
      </div>
    </section>;
};